import React from 'react';

const Payment = () => {
  return (
    <div className='shadow  h-100 mx-auto'>
      <h1 className='bg-dark text-light'>Payment</h1>
      <h2 className='mt-5'> Payment is coming ......</h2>
    </div>
  );
};

export default Payment;